module.exports = __webpack_public_path__ + "5bf6c1f24905216576dbdc08f8b3b6b3.png";